import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { UserSlice } from "./CommonInitialsate";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import { Managernote } from "../components/KanbanBoard/ManagerNotesslice";
import { Twofactor } from "../components/Settings/Twofactorslice";

const persistConfig = {
  key: "root",
  version: 1,
  storage,
  whitelist: ["user", "twofactor"],
};

const rootReducer = combineReducers({
  user: UserSlice.reducer,
  note: Managernote.reducer,
  twofactor: Twofactor.reducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
